import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  ReferralLeaderboardEntry,
  ReferralLeaderboardMode,
  ReferralSummary,
} from '../../models/referral/referral.model';

interface ReferralState {
  summary: ReferralSummary | null;
  leaderboard: ReferralLeaderboardEntry[];
  leaderboardMode: ReferralLeaderboardMode;
  summaryError: string | null;
  leaderboardError: string | null;
}

const initialState: ReferralState = {
  summary: null,
  leaderboard: [],
  leaderboardMode: 'monthly',
  summaryError: null,
  leaderboardError: null,
};

const referralSlice = createSlice({
  name: 'referral',
  initialState,
  reducers: {
    setReferralSummary(state, action: PayloadAction<ReferralSummary | null>) {
      state.summary = action.payload;
    },
    setReferralLeaderboard(
      state,
      action: PayloadAction<ReferralLeaderboardEntry[]>
    ) {
      state.leaderboard = action.payload;
    },
    setReferralLeaderboardMode(
      state,
      action: PayloadAction<ReferralLeaderboardMode>
    ) {
      state.leaderboardMode = action.payload;
    },
    setReferralSummaryError(state, action: PayloadAction<string | null>) {
      state.summaryError = action.payload;
    },
    setReferralLeaderboardError(state, action: PayloadAction<string | null>) {
      state.leaderboardError = action.payload;
    },
    resetReferralState: () => initialState,
  },
});

export const referralActions = referralSlice.actions;
export default referralSlice.reducer;
